import type { FC } from 'react';
import React from 'react';
import { Divider, TextV2 } from '@withjoy/joykit';
import type { BrandDataType } from '../../BrandsList';
import { useCatalogRouting } from '../../../../useCatalogRouting';
import { StyledBrandGroupContainer, StyledBrandGroupWrapper, StyledBrandItem, styles } from './BrandGroupList.styles';
import { useCatalogRegistryTelemetry } from '../../../../Catalog.telemetry';

interface BrandGroupListProps {
  items: BrandDataType[];
  title: string;
  refElement: React.Ref<HTMLDivElement>;
}

export const BrandGroupList: FC<BrandGroupListProps> = props => {
  const { items, title, refElement } = props;

  const { goToBrandPage } = useCatalogRouting();
  const { onBrandClicked } = useCatalogRegistryTelemetry();

  const handleClick = (brand: BrandDataType) => {
    onBrandClicked({
      destinationProductCatalogCategoryId: brand.id,
      destinationProductCatalogCategoryPublicUrlPath: brand.publicUrlPath,
      destinationProductCatalogCategoryTitle: brand.name,
    });
    goToBrandPage(brand.publicUrlPath);
  };

  return (
    <StyledBrandGroupContainer
      id={title}
      __css={styles.brandGroupContainer}
      ref={refElement}
    >
      <TextV2 typographyVariant="hed6">{title}</TextV2>
      <StyledBrandGroupWrapper __css={styles.brandGroupWrapper}>
        {items.map(item => (
          <StyledBrandItem
            key={item.id}
            __css={styles.brandItem}
            onClick={() => handleClick(item)}
          >
            <TextV2
              typographyVariant="body3"
              marginBottom={4}
            >
              {item.name}
            </TextV2>
            <Divider />
          </StyledBrandItem>
        ))}
      </StyledBrandGroupWrapper>
    </StyledBrandGroupContainer>
  );
};
